import React from "react";
import HeroSection from "../components/common/HeroSection";
import SectionTitle from "../components/common/SectionTitle";
import ClientLogos from "../components/home/ClientLogos";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import Partners from "../components/home/Partners";

const About = () => {
  return (
    <div className="about-page">
      <HeroSection
        title="About Us"
        breadcrumb={[{ name: "About Us" }]}
        background="/assets/images/about/bg.png"
      />

      <div className="min-h-screen">
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-7 gap-16 items-center">
              <div
                className="relative md:col-span-3" // style="opacity: 1;"
              >
                <div className="absolute -top-8 -left-8 w-64 h-64 bg-blue-50 rounded-full opacity-70 z-0"></div>
                <div className="relative z-10 pt-5 pl-5">
                  <div className="absolute top-0 left-0 w-24 h-24 border-t-4 border-l-4 border-primary"></div>
                  <img
                    alt="About STISSA Technology LLP (TISSA Technology)"
                    loading="lazy"
                    width="600"
                    height="400"
                    decoding="async"
                    data-nimg="1"
                    className="rounded-xl shadow-lg object-cover w-full h-auto"
                    src="/assets/images/about/1.jpg"
                    // style="color: transparent;"
                  />
                  <div className="absolute -bottom-5 -right-5 w-24 h-24 border-b-4 border-r-4 border-primary"></div>
                </div>
                <div className="bg-black/70 absolute -right-5 top-1/3 bg-primary text-white p-4 rounded-full shadow-lg z-20 hidden lg:flex items-center justify-center w-28 h-28 flex-col">
                  <span className="text-3xl font-bold">7+</span>
                  <span className="text-xs uppercase tracking-wider">
                    Years
                  </span>
                </div>
              </div>
              <div
                className="space-y-6 md:col-span-4" // style="opacity: 1; transform: none;"
              >
                <div>
                  <span className="text-primary font-medium text-lg inline-block py-1 rounded-full bg-primary bg-opacity-10 mb-3">
                    About Our Company
                  </span>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-6 leading-tight">
                    Leading the Way in{" "}
                    <span className="text-primary">
                      Innovative IT Solutions
                    </span>{" "}
                    and Services
                  </h2>
                </div>
                <p className="text-gray-600 text-justify leading-relaxed">
                  STISSA Technology LLP (TISSA Technology) has been forged by
                  highly experienced experts dedicated to providing
                  comprehensive IT and digital solutions under one roof.
                  Equipped with cutting-edge technology and a team of
                  knowledgeable professionals, we deliver customized,
                  user-friendly solutions that exceed client expectations.
                </p>
                <p className="text-gray-600 text-justify leading-relaxed">
                  As a premier application &amp; software development services
                  provider, STISSA Technology LLP (TISSA Technology) offers
                  professional app and web development services worldwide.
                  Finding the right offshore software development partner can
                  transform your business, and we pride ourselves on delivering
                  exceptional custom web designs at competitive prices.
                </p>
                <div className="pt-4">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800">
                    Our Expertise Includes:
                  </h3>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/custom-software-development"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Custom Software Development
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/mobile-application-development"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Mobile Application Development
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/api-development"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        API Development
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/integration"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Integration
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/data-analytics"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Data Analytics
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/big-data"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Big Data
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/ai-ml-genai"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        AI, ML & GEN AI
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/sap-services"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        SAP Services
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/odoo-services"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Odoo Services
                      </Link>
                    </li>

                    <li className="flex items-center space-x-2">
                      <ChevronRight className="w-5 h-5" />
                      <Link
                        to="/services/consulting"
                        className="text-gray-700 hover:underline hover:text-blue-700"
                      >
                        Consulting
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="pt-6">
                  <a
                    href="/services"
                    className="bg-blue-500 inline-block bg-primary hover:bg-blue-900 text-white font-medium py-3 px-8 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg"
                  >
                    Explore Our Services
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-16 bg-gray-100">
          <div className="container mx-auto px-4">
            <div
              className="text-center max-w-3xl mx-auto mb-16"
              // style="opacity: 1; transform: none;"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Our Core Values
              </h2>
              <div className="w-20 h-1 bg-black mx-auto mb-6"></div>

              <p className="text-gray-600">
                These principles guide our work and define our company culture
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div
                className="bg-white p-8 rounded-xl shadow-soft text-center hover:shadow-md transition-shadow duration-300 border-t-4 border-gray-500"
                // style="opacity: 1; transform: none;"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  Innovation
                </h3>
                <p className="text-gray-600">
                  We continuously seek new ideas and technologies to deliver
                  cutting-edge solutions.
                </p>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft text-center hover:shadow-md transition-shadow duration-300 border-t-4 border-gray-500"
                // style="opacity: 1; transform: none;"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  Excellence
                </h3>
                <p className="text-gray-600">
                  We maintain the highest standards in all aspects of our work.
                </p>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft text-center hover:shadow-md transition-shadow duration-300 border-t-4 border-gray-500"
                // style="opacity: 1; transform: none;"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  Integrity
                </h3>
                <p className="text-gray-600">
                  We operate with honesty, transparency, and ethical business
                  practices.
                </p>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft text-center hover:shadow-md transition-shadow duration-300 border-t-4 border-gray-500"
                // style="opacity: 1; transform: none;"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  Collaboration
                </h3>
                <p className="text-gray-600">
                  We build strong partnerships with our clients and work
                  together as a team.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
              <div
                className="relative" // style="opacity: 1; transform: none;"
              >
                <div className="absolute top-0 left-0 w-20 h-20 bg-blue-50 rounded-full opacity-70 z-0"></div>
                <div className="relative z-10">
                  <div className="bg-primary bg-opacity-10 p-4 rounded-full inline-block mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-target h-8 w-8 text-primary"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <circle cx="12" cy="12" r="6"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                    </svg>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-4">
                    Our Mission
                  </h3>
                  <div className="w-20 h-1 bg-primary mb-6"></div>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    Exceed clients expectations by going beyond software to
                    provide best application development solutions that
                    transform data into knowledge, enabling them to solve their
                    problems. We strive to build long-term relationships with
                    our clients by delivering high-quality solutions that
                    address their unique business challenges.
                  </p>
                </div>
              </div>
              <div
                className="relative" // style="opacity: 1; transform: none;"
              >
                <div className="absolute bottom-0 right-0 w-20 h-20 bg-blue-50 rounded-full opacity-70 z-0"></div>
                <div className="relative z-10">
                  <div className="bg-primary bg-opacity-10 p-4 rounded-full inline-block mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-users h-8 w-8 text-primary"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-4">
                    Our Vision
                  </h3>
                  <div className="w-20 h-1 bg-primary mb-6"></div>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    Our Vision is to be a leading Software Solution company in
                    IT sector and progress in our current position in market. We
                    know that Customers growth is our growth, so we commit our
                    customers to help in achieving their business goals. We
                    believe in working with accuracy and the highest quality. We
                    want to be known as the reliable, innovative and user
                    friendly software service provider in IT industry.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-primary-dark text-white py-20 md:py-24 relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('/assets/images/about/bg.png')] bg-repeat "></div>
          <div className="absolute top-0 left-0 w-40 h-40 bg-white opacity-5 rounded-full translate-x-[-50%] translate-y-[-50%]"></div>
          <div className="absolute bottom-0 right-0 w-60 h-60 bg-white opacity-5 rounded-full translate-x-[30%] translate-y-[30%]"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div
              className="text-center max-w-3xl mx-auto mb-16"
              // style="opacity: 1; transform: none;"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Our Impact in Numbers
              </h2>
              <div className="w-20 h-1 bg-white mx-auto mb-6"></div>
              <p className="text-blue-100 text-lg">
                Milestones that showcase our commitment to excellence
              </p>
            </div>
            <div
              className="grid grid-cols-2 md:grid-cols-4 gap-8"
              style={{ opacity: 1 }}
            >
              <div
                className="text-center   bg-opacity-5 p-8 rounded-lg backdrop-blur-lg border border-white border-opacity-50 hover:bg-opacity-10 transition-all duration-300"
                // style="opacity: 1; transform: none;"
              >
                <div className="bg-white bg-opacity-20 p-4 rounded-full inline-flex items-center justify-center mb-4 mx-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-award h-8 w-8"
                  >
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                    <circle cx="12" cy="8" r="6"></circle>
                  </svg>
                </div>
                <h3 className="text-4xl font-bold mb-2">7+</h3>
                <p className="text-blue-100 uppercase tracking-wider text-sm">
                  Years Experience
                </p>
              </div>
              <div
                className="text-center   bg-opacity-5 p-8 rounded-lg backdrop-blur-lg border border-white border-opacity-50 hover:bg-opacity-10 transition-all duration-300"
                // style="opacity: 1; transform: none;"
              >
                <div className="bg-white bg-opacity-20 p-4 rounded-full inline-flex items-center justify-center mb-4 mx-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-users h-8 w-8"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <h3 className="text-4xl font-bold mb-2">200+</h3>
                <p className="text-blue-100 uppercase tracking-wider text-sm">
                  Satisfied Clients
                </p>
              </div>
              <div
                className="text-center   bg-opacity-5 p-8 rounded-lg backdrop-blur-lg border border-white border-opacity-50 hover:bg-opacity-10 transition-all duration-300"
                // style="opacity: 1; transform: none;"
              >
                <div className="bg-white bg-opacity-20 p-4 rounded-full inline-flex items-center justify-center mb-4 mx-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-clock h-8 w-8"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
                <h3 className="text-4xl font-bold mb-2">500+</h3>
                <p className="text-blue-100 uppercase tracking-wider text-sm">
                  Projects Completed
                </p>
              </div>
              <div
                className="text-center   bg-opacity-5 p-8 rounded-lg backdrop-blur-lg border border-white border-opacity-50 hover:bg-opacity-10 transition-all duration-300"
                // style="opacity: 1; transform: none;"
              >
                <div className="bg-white bg-opacity-20 p-4 rounded-full inline-flex items-center justify-center mb-4 mx-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-target h-8 w-8"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                </div>
                <h3 className="text-4xl font-bold mb-2">30+</h3>
                <p className="text-blue-100 uppercase tracking-wider text-sm">
                  Expert Professionals
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div
              className="text-center max-w-3xl mx-auto mb-16"
              // style="opacity: 1; transform: none;"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Why Choose TISSA Technology?
              </h2>
              <div className="w-20 h-1 bg-black mx-auto mb-6"></div>

              <p className="text-gray-600 text-lg">
                We combine technical expertise with business understanding to
                deliver solutions that drive growth and innovation.
              </p>
            </div>
            <div
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
              // style="opacity: 1;"
            >
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Expert Team
                    </h3>
                    <p className="text-gray-600">
                      Our team consists of highly skilled professionals with
                      extensive experience in various technologies and
                      industries.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Quality Assurance
                    </h3>
                    <p className="text-gray-600">
                      We follow rigorous quality assurance processes to ensure
                      that all our deliverables meet the highest standards.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Timely Delivery
                    </h3>
                    <p className="text-gray-600">
                      We understand the importance of deadlines and strive to
                      deliver all projects on time without compromising on
                      quality.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Cost-Effective Solutions
                    </h3>
                    <p className="text-gray-600">
                      We offer competitive pricing without compromising on the
                      quality of our services.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Customer-Centric Approach
                    </h3>
                    <p className="text-gray-600">
                      We prioritize our clients' needs and goals, ensuring that
                      our solutions align with their business objectives.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300 hover:border-primary hover:border-opacity-50"
                // style="opacity: 1; transform: none;"
              >
                <div className="flex items-start mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-full mr-4 flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-circle-check-big h-6 w-6 text-primary"
                    >
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">
                      Continuous Support
                    </h3>
                    <p className="text-gray-600">
                      We provide ongoing support and maintenance to ensure that
                      our solutions continue to perform optimally.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-16 bg-gradient-to-r from-blue-500 to-blue-900 text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Ready to Transform Your Ideas Into Reality?
              </h2>
              <p className="text-lg md:text-xl text-blue-200 mb-8">
                Let’s discuss how our IT solutions can help your business grow
                and succeed.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a
                  href="/contact-us"
                  className="bg-white text-blue-700 font-bold py-4 px-8 rounded-lg shadow-lg hover:bg-blue-100 transition duration-300"
                >
                  Contact Us Today
                </a>

                {/* <!-- Optional secondary button -->
        <!-- 
        <a
          href="/case-studies"
          className="border-2 border-white text-white font-bold py-4 px-8 rounded-lg hover:bg-white hover:text-blue-700 transition duration-300"
        >
          View Our Case Studies
        </a>
        --> */}
              </div>
            </div>
          </div>
        </section>
      </div>
<Partners />
      <ClientLogos />
    </div>
  );
};

export default About;
